// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"227e1d85","488":"3ba7255f","735":"ab834f92"}[chunkId] + ".chunk.js";
};